import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import type { ButtonProps } from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

import { CostumeButtonStyled } from "./costumeButtonStyled";

interface ICostumeButton extends ButtonProps {
  icon?: React.ReactNode;
  className?: string;
  children?: React.ReactNode;
  loading?: boolean;
}
function CostumeButton({
  children,
  className,
  color,
  loading,
  disabled,
  sx,
  ...rest
}: ICostumeButton) {
  const isDisabled = Boolean(loading || disabled);
  const buttonSx = Array.isArray(sx) ? sx : [sx];

  return (
    <Box>
      <CostumeButtonStyled>
        <Button
          disabled={isDisabled}
          className={`btn ${className}`}
          aria-label={loading ? "Loading" : undefined}
          sx={[
            ...buttonSx,
            isDisabled && {
              "&.Mui-disabled": {
                backgroundColor: "#EEF1F4 !important",
                border: "1px solid #C8D0D8 !important",
                boxShadow: "none !important",
                color: "#687482 !important",
                opacity: 1,
              },
              "&.Mui-disabled svg": {
                opacity: 0.5,
              },
            },
          ]}
          {...rest}
        >
          {loading ? (
            <CircularProgress
              size={20}
              disableShrink
              style={{ color: "#fff" }}
            />
          ) : (
            children
          )}
        </Button>
      </CostumeButtonStyled>
    </Box>
  );
}

export default CostumeButton;
